var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTk(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#41479B"
    },
    d: "M473.655,423.724H38.345C17.167,423.724,0,406.557,0,385.379V126.621 c0-21.177,17.167-38.345,38.345-38.345h435.31c21.177,0,38.345,17.167,38.345,38.345V385.38 C512,406.557,494.833,423.724,473.655,423.724z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M476.69,370.759H123.586c-4.875,0-8.828-3.953-8.828-8.828l0,0c0-4.875,3.953-8.828,8.828-8.828 H476.69l8.828,8.828L476.69,370.759z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFE15A"
    },
    d: "M481.103,344.276H123.586c0,0,141.241-158.897,273.655-194.207c0,0-44.138,114.759,61.793,185.379 h22.069c2.438,0,4.414,1.976,4.414,4.414l0,0C485.517,342.3,483.542,344.276,481.103,344.276z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M108.162,293.173l3.425,10.271l10.826,0.084c1.401,0.011,1.983,1.8,0.855,2.632l-8.71,6.431 l3.266,10.323c0.423,1.336-1.099,2.442-2.239,1.626l-8.808-6.295l-8.808,6.295c-1.14,0.815-2.662-0.29-2.239-1.626l3.266-10.323 l-8.71-6.431c-1.128-0.833-0.546-2.622,0.855-2.632l10.826-0.084l3.425-10.271C105.837,291.843,107.719,291.843,108.162,293.173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M107.901,151.97l2.778,8.332l8.783,0.068c1.138,0.009,1.609,1.46,0.694,2.135l-7.065,5.218 l2.649,8.374c0.343,1.085-0.892,1.981-1.816,1.32l-7.146-5.108l-7.146,5.108c-0.925,0.661-2.159-0.236-1.816-1.32l2.649-8.374 l-7.065-5.218c-0.915-0.675-0.444-2.126,0.694-2.135l8.783-0.068l2.778-8.332C106.015,150.892,107.541,150.892,107.901,151.97z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M41.359,203.53l2.778,8.332l8.783,0.068c1.138,0.009,1.609,1.46,0.694,2.135l-7.065,5.218 l2.649,8.374c0.343,1.085-0.892,1.981-1.816,1.32l-7.146-5.108l-7.146,5.108c-0.925,0.661-2.159-0.236-1.816-1.32l2.649-8.374 l-7.065-5.218c-0.915-0.675-0.444-2.126,0.694-2.135l8.783-0.068l2.778-8.332C39.474,202.451,41,202.451,41.359,203.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F5F5"
    },
    d: "M155.489,200.014l2.138,6.412l6.759,0.052c0.875,0.007,1.238,1.123,0.534,1.643l-5.438,4.015 l2.039,6.444c0.264,0.834-0.686,1.525-1.398,1.015l-5.498-3.93l-5.498,3.93c-0.712,0.509-1.662-0.181-1.398-1.015l2.039-6.444 l-5.438-4.015c-0.704-0.52-0.341-1.636,0.534-1.643l6.759-0.052l2.138-6.412C154.038,199.185,155.212,199.185,155.489,200.014z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTk);
export default __webpack_public_path__ + "static/media/tk.016f7dad69d648655d0833287f99d2b9.svg";
export { ForwardRef as ReactComponent };